query MobileDashboardUniqueIssues(
	$offset: Int!
	$limit: Int!
	$sort: mobile_unique_issuesSort
	$daysFilter: ConditionInt
	$severityFilter: ConditionString
	$issueTypeFilter: ConditionString
	$businessUnitFilter: ConditionString
	$platformFilter: ConditionString
	$appIdFilter: ConditionString
	$textSearch: mobile_unique_issuesSearchInsensitive
) {
	mobile_unique_issues(
		offset: $offset
		limit: $limit
		sort: $sort
		last_seen_last_n_days: $daysFilter
		severity_eq: $severityFilter
		issue_type_eq: $issueTypeFilter
		business_unit_eq: $businessUnitFilter
		platform_eq: $platformFilter
		app_id_eq: $appIdFilter
		text_contains: $textSearch
	) {
		tenant_id
		signature
		last_issue_id
		last_run_id
		business_unit
		platform
		app_id
		product_name
		issue_type
		severity
		element_description
		first_seen
		last_seen
		num_instances
	}
	total: mobile_unique_issues(
		last_seen_last_n_days: $daysFilter
		severity_eq: $severityFilter
		issue_type_eq: $issueTypeFilter
		business_unit_eq: $businessUnitFilter
		platform_eq: $platformFilter
		app_id_eq: $appIdFilter
		text_contains: $textSearch
	) {
		signature_count
	}
}
